module.exports = __webpack_public_path__ + "img/type_alu.58013da8.svg";